import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Update `}<a parentName="p" {...{
        "href": "https://posthog.com/docs/integrate/server/node"
      }}>{`posthog-node`}</a>{` to version 1.2.0 or above to make use of the new functionality.`}</p>
    <p>{`To check a flag that's matching by companies, specify groups in relevant feature flag call:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const isFlagEnabled = await posthog.isFeatureEnabled('new-groups-feature', '[distinct id]', false, { company: 'id:5' })

if (isFlagEnabled) {
    // Toggle feature-flag specific behavior
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      